'use client'

import { FC, useContext, useMemo, useState } from 'react'

import { ModalBaseContext } from './ModalBaseContext'
import { IModalBaseProviderProps } from './types'

export const ModalBaseProvider: FC<IModalBaseProviderProps> = ({
  children,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  const contextValue = useMemo(() => {
    return { modalOpen, setModalOpen }
  }, [modalOpen, setModalOpen])

  return (
    <ModalBaseContext.Provider value={contextValue}>
      {children}
    </ModalBaseContext.Provider>
  )
}

export const useModalBaseProvider = () => useContext(ModalBaseContext)
